import { render, staticRenderFns } from "./xizaoka_add.vue?vue&type=template&id=01a3bcd5&scoped=true&"
import script from "./xizaoka_add.vue?vue&type=script&lang=js&"
export * from "./xizaoka_add.vue?vue&type=script&lang=js&"
import style0 from "./xizaoka_add.vue?vue&type=style&index=0&id=01a3bcd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3bcd5",
  null
  
)

export default component.exports